(function () {
  angular.module('kareo.ui.shared.components.k-therapy-cap', [
    'kareo.ui.shared.services.therapy-cap'
  ])
  .component('kTherapyCap', {
    template: require('./k-therapy-cap.pug')(),
    controller: TherapyCapController,
    controllerAs: 'vm',
    bindings: {
      providerId: '<',
      eligibilityData: '<'
    }
  });

  TherapyCapController.$inject = ['therapyCapService', '$scope'];

  function TherapyCapController(therapyCapService, $scope) {
    const vm = this;
    vm.show = show;

    // watching the data as information needs to be pulled from the service
    // everytime the data changes
    $scope.$watch(() => {
      return vm.eligibilityData;
    }, (newVal, oldVal) => {
      if (newVal) {
        init();
      }
    });

    // functions
    function init() {
      if (!vm.eligibilityData || !vm.eligibilityData.maxAllowedTherapyCapAmount) {
        return;
      }

      vm.therapyCapInfo = {
        used: 0,
        total: vm.eligibilityData.maxAllowedTherapyCapAmount
      };
      vm.specialtyMatched = false;

      // Lanuguage: spelling is as per the value returned from service
      const spacialities = [
        35, // 'Occupational Therapy'
        48, // 'Physical Therapy'
        59 // 'Speech Lanuguage Pathology'
      ];

      vm.isLoading = true;
      therapyCapService.getProviderSpeciality(vm.providerId)
      .then((response) => {
        if (!response) return;
        if (spacialities.indexOf(response.kareoSpecialtyID) === 0
            && vm.eligibilityData.isOccupationalTherapyADAvailable) {
          vm.therapyCapInfo.used = vm.eligibilityData.occupationTherapyADAmountUsed;
          vm.specialtyMatched = true;
        } else if (spacialities.indexOf(response.kareoSpecialtyID) > 0
                    && vm.eligibilityData.isPhysicalOrSpeechTherapyAEAvailable) {
          vm.therapyCapInfo.used = vm.eligibilityData.physicalOrSpeechTherapyAEAmountUsed;
          vm.specialtyMatched = true;
        }
      })
      .finally(() => {
        vm.isLoading = false;
      });
    }

    function show() {
      return vm.specialtyMatched;
    }
  }
})();
